import { useMemo, useState } from 'react'
import './Glossary.scss'
import GlossarySearch from './GlossarySearch/GlossarySearch'
import GlossaryItems from './GlossaryItems/GlossaryItems'
import GlossaryAlphabet from './GlossaryAlphabet/GlossaryAlphabet'
import GlossaryFooter from './GlossaryFooter/GlossaryFooter'

const formatIntoGroups = (accumulator, currentGlossaryItem) => {
  // if the letter of the first glossary item exists in the accumulator then add it to that key
  if (!accumulator[currentGlossaryItem.letter]) {
    accumulator[currentGlossaryItem.letter] = []
  }

  accumulator[currentGlossaryItem.letter].push(currentGlossaryItem)

  return accumulator
}

const filterGlossaryItemsWhenSearching = (
  { word, description },
  searchTerm
) => {
  return description.includes(searchTerm) || word.includes(searchTerm)
}

const GlossaryPage = ({ glossaryItems: items, footerHeading, footerText }) => {
  const [glossaryItems, setGlossaryItems] = useState(items)
  // memorize the values so its less expensive per render
  const glossaryGroups = useMemo(
    () => glossaryItems.reduce(formatIntoGroups, {}),
    [glossaryItems]
  )

  const handleSearchSubmission = (searchTerm) => {
    const filtereditems = items.filter((glossaryItem) =>
      filterGlossaryItemsWhenSearching(glossaryItem, searchTerm)
    )

    setGlossaryItems(filtereditems)
  }

  return (
    <>
      <GlossaryAlphabet glossaryLetters={Object.keys(glossaryGroups)} />
      <GlossarySearch
        className="p-glossary-page__search"
        onSubmit={handleSearchSubmission}
      />
      <GlossaryItems glossary={glossaryGroups} />
      <hr className="p-glossary-page__glossary-divider" />
      <GlossaryFooter footerHeading={footerHeading} footerText={footerText} />
    </>
  )
}

export default GlossaryPage
